import React, { useEffect, useState } from 'react';
import { useSelector, useDispatch } from 'react-redux';

import { AppState } from '../store';
import {
  ToggleChatBotStatus,
  StartChatBotLog
} from '../store/chatStatus/actions';
import { fetchChatDataAction } from '../store/chatmessage/actions';

import CloseDialog from './CloseDialog';
import ChatBotOpenFrame from './ChatBotOpenFrame';
import ChatBotMainFrame from './ChatBotMainFrame';

// const ChatBotMainFrame = React.lazy(() => import('./ChatBotMainFrame'));

const ChatBot: React.FC = () => {
  const dispatch = useDispatch();
  const [toggle, setToggle] = useState(false);
  const start = useSelector((state: AppState) => state.chatStatus.start);
  const status = useSelector((state: AppState) => state.chatStatus.status);
  const loading = useSelector((state: AppState) => state.chatStatus.loading);

  const chatSetting = useSelector((state: AppState) => state.chatSetting);
  const initialLoading = useSelector(
    (state: AppState) => state.chatStatus.initialLoading
  );

  const [closeDialogIsOpen, setCloseDialogIsOpen] = useState(false);

  useEffect(() => {
    if (initialLoading === true) {
      dispatch(fetchChatDataAction());
    }
  }, [initialLoading, dispatch]);

  const toggleCloseDialog = () => {
    setCloseDialogIsOpen(!closeDialogIsOpen);
  };

  async function toggleChatbot(toggle: boolean) {
    return new Promise(resolve => {
      if (!toggle) {
        dispatch(StartChatBotLog());
      }
      dispatch(ToggleChatBotStatus());
      resolve();
    });
  }

  return (
    <React.Fragment>
      {!status ? (
        <ChatBotOpenFrame
          toggle={toggle}
          setToggle={setToggle}
          toggleChatbot={toggleChatbot}
          toggleCloseDialog={toggleCloseDialog}
          start={start}
          loading={loading}
        />
      ) : (
        <ChatBotMainFrame
          toggle={toggle}
          setToggle={setToggle}
          chatSetting={chatSetting}
          loading={loading}
          start={start}
          toggleCloseDialog={toggleCloseDialog}
          toggleChatbot={toggleChatbot}
        />
      )}
      {closeDialogIsOpen === true && (
        <CloseDialog
          dispatch={dispatch}
          btnColor={chatSetting.mainColor}
          toggleCloseDialog={toggleCloseDialog}
        />
      )}
    </React.Fragment>
  );
};

export default ChatBot;
